export default function isRenderProp(prop) {
  return typeof prop === 'function';
}